import { render } from "./CalendarioLive.vue?vue&type=template&id=6c09d4aa"
import script from "./CalendarioLive.vue?vue&type=script&lang=js"
export * from "./CalendarioLive.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__